import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const FacePokerface = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 20"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path
          stroke="#344054"
          d="M2.793 10c0 5.78 1.927 7.708 7.708 7.708s7.709-1.928 7.709-7.709-1.928-7.708-7.709-7.708-7.708 1.928-7.708 7.708"
          clipRule="evenodd"
        />
        <path stroke="#FF6A00" d="M13.42 8.333V6.666M7.583 8.333V6.666" />
        <path stroke="#344054" d="M12.17 13.333H8.835" />
      </g>
    </svg>
  );
};
export default FacePokerface;
